import { Directive } from "@angular/core";

/**
 * Used within toolbar rows to display informational content with consistent styling.
 * Provides proper spacing and icon alignment.
 *
 * @example
 * <mgd-toolbar-info>
 *   <mat-icon>access_time</mat-icon>2025-01-19
 * </mgd-toolbar-info>
 */
@Directive({
    selector: "mgd-toolbar-info",
    host: {
        class: "mgd-toolbar-info"
    }
})
export class ToolbarInfoDirective {}
